import get from 'lodash/get'
import { translatePassengersToPkg } from '../../details-client/util/translatePassengersToPkg.js'

const isSameCity = (airportCodeA, airportCodeB, airports) => {
  if (!airportCodeA || !airportCodeB) {
    return false
  }

  if (airportCodeA === airportCodeB) {
    return true
  }

  const cityCodeA = airports?.[airportCodeA]?.cityCode
  const cityCodeB = airports?.[airportCodeB]?.cityCode

  return Boolean(cityCodeA) && cityCodeA === cityCodeB
}

const translateSearchRequest = (searchRequest, passengers) => {
  let [departingFrom, returningFrom, travelDate, returnDate, origin, destination] = [null, null, '', '']

  const sliceMatches = searchRequest.slicesURL.match(new RegExp(/(\w{3}-\w{3}-\d{8})/g))
  const { slices, airports } = searchRequest
  // TODO: GET this from Search Request
  // Trip type
  let tripType = 'MD'

  if (
    slices.length === 2 &&
    slices[0].originAirport === slices[1].destinationAirport &&
    slices[1].originAirport === slices[0].destinationAirport
  ) {
    tripType = 'RT'
  } else if (searchRequest.slices.length < 2) {
    tripType = 'OW'
  }

  if (slices && slices.length && airports) {
    // Get the params from url
    origin = slices[0].originAirport
    /**
     * A two slice trip that ends in the city it started from is a return trip even when the
     * inner airports don't match (open jaw), so the outbound arrival is the destination.
     * Falling back to the final arrival there would resolve the destination to the origin.
     */
    const endsWhereItStarted =
      slices.length === 2 && isSameCity(slices[1].destinationAirport, slices[0].originAirport, airports)
    destination =
      slices.length > 1 && !endsWhereItStarted
        ? slices[slices.length - 1].destinationAirport
        : slices[0].destinationAirport

    // Get the data from params
    const originData = airports[origin]
    const destinationData = airports[destination]

    // Get the Departure Date
    travelDate = slices[0].travelDate
    returnDate = get(slices, '[1].travelDate', '')

    departingFrom = {
      cityCode: originData.cityCode,
      airportCode: originData.airportCode,
      cityName: originData.cityName,
      cityId: originData.cityId,
      stateName: originData?.stateName,
      stateCode: originData?.stateCode,
      countryName: originData?.countryName,
      countryCode: originData?.countryCode,
    }
    returningFrom = {
      cityCode: destinationData.cityCode,
      airportCode: destinationData.airportCode,
      cityName: destinationData.cityName,
      cityId: destinationData.cityId,
      stateName: destinationData?.stateName,
      stateCode: destinationData?.stateCode,
      countryName: destinationData?.countryName,
      countryCode: destinationData?.countryCode,
    }
  }

  const travelers = translatePassengersToPkg(searchRequest, passengers)

  return {
    airports,
    slices: sliceMatches || [],
    cabinClass: searchRequest.params['cabin-class'],
    travelers,
    tripType,
    departingFrom,
    returningFrom,
    travelDate,
    returnDate,
    origin,
    destination,
  }
}

export { translateSearchRequest }
